import { useNavigate } from 'react-router-dom';

import { ArrowRight } from 'lucide-react';

import { Button } from '@/components/ui/button/Button';
import CharacterSad from '@/components/svg/CharacterSad';
import RhymeLogo from '@/components/svg/RhymeLogo';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();

  return (
    <div
      className={
        'w-full bg-light h-screen p-10 flex flex-col items-center gap-10 '
      }
    >
      <div className='w-[125px] [&>svg]:w-full text-center'>
        <RhymeLogo />
      </div>

      <div className='flex flex-col border border-light-grey rounded-xl w-[380px] max-w-full shadow-panel bg-white'>
        <div className='bg-gradient-to-b from-red/10 to-white p-8 [&>svg]:inline-block [&>svg]:max-w-full text-center'>
          <CharacterSad />
        </div>
        <div className='flex flex-col px-8 pb-8 text-center'>
          <h1 className={'text-[24px] font-bold mb-8'}>
            Oops! <br /> Payment failed.
          </h1>
          <p className={'font-medium mb-6'}>
            Something went wrong on the side of your bank. Please try again
            later.
          </p>
          <Button
            variant={'yellow'}
            onClick={() => navigate('/settings/billing')}
            className={'flex items-center gap-4'}
          >
            Retry order <ArrowRight />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
